import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { notification } from "antd";
import { Strings } from "../../../../../dataProvider/localize";
import { cancelSwmsApprovalV2 } from "../../../../../actions/v2/JobSwmsTaskActions";
import styles from "./SwmsCancelApprovalConfirmModal.module.css";

const RefreshIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="currentColor" className={styles.icon}>
    <path d="M88 256L232 256C241.7 256 250.5 250.2 254.2 241.2C257.9 232.2 255.9 221.9 249 215L202.3 168.3C277.6 109.7 386.6 115 455.8 184.2C530.8 259.2 530.8 380.7 455.8 455.7C380.8 530.7 259.3 530.7 184.3 455.7C174.1 445.5 165.3 434.4 157.9 422.7C148.4 407.8 128.6 403.4 113.7 412.9C98.8 422.4 94.4 442.2 103.9 457.1C113.7 472.7 125.4 487.5 139 501C239 601 401 601 501 501C601 401 601 239 501 139C406.8 44.7 257.3 39.3 156.7 122.8L105 71C98.1 64.2 87.8 62.1 78.8 65.8C69.8 69.5 64 78.3 64 88L64 232C64 245.3 74.7 256 88 256z" />
  </svg>
);

export default function SwmsCancelApprovalConfirmModal({ swms, jobId, onClose, onSuccess }) {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  const formName = swms && swms.swms_form_name ? swms.swms_form_name : "SWMS";
  const formId = swms && swms.swms_form_id ? swms.swms_form_id : "N/A";

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget && !submitting) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (!swms || !swms.swms_form_id || !jobId) {
      notification.error({
        message: Strings.error_title,
        description: Strings.generic_error,
        className: "ant-error"
      });
      onClose();
      return;
    }

    setSubmitting(true);
    dispatch(cancelSwmsApprovalV2(jobId, swms.swms_form_id)).then((message) => {
      setSubmitting(false);
      notification.success({
        message: Strings.success_title,
        description: message || "Approval cancelled successfully.",
        className: "ant-success"
      });
      if (onSuccess) {
        onSuccess();
      } else {
        onClose();
      }
    }).catch((err) => {
      setSubmitting(false);
      notification.error({
        message: Strings.error_title,
        description: err || Strings.generic_error,
        className: "ant-error"
      });
    });
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <div className={styles.body}>
          <div className={styles.iconCircle}>
            <RefreshIcon />
          </div>
          <h3 className={styles.title}>Cancel Approval?</h3>
          <p className={styles.message}>
            This will cancel the pending approval for <strong>{formName}</strong>.
          </p>
          <p className={styles.message}>
            Reviewers who have not responded will be notified the request has been withdrawn. The SWMS will return to <strong>Draft</strong> so you can re-route to different reviewers.
          </p>

          <div className={styles.actions}>
            <button type="button" className={styles.confirmBtn} onClick={handleConfirm} disabled={submitting}>
              {submitting ? (
                <CircularProgress size={16} style={{ color: "#fff" }} />
              ) : (
                <>
                  <span className={styles.confirmIconWrap}>
                    <RefreshIcon />
                  </span>
                  Yes, Cancel &amp; Return to Draft
                </>
              )}
            </button>
            <button type="button" className={styles.cancelBtn} onClick={onClose} disabled={submitting}>
              Keep Pending
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
